export default "__VITE_ASSET__4cf9edbb__"